// import mockedApiCalls from '../mockedApiCalls/mockPaymentConfig';
import axios from 'axios';

export function fetchPaymentConfig({ url, endpoint, config = {} }) {
    return axios.post(`${url}${endpoint}`, config);
}

export function genericPost({ url, data = {}, headers = {} }) {
    return axios({ method: 'post', url: url, headers: headers, data: data });
}
